// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"375":"repo","414":"image","529":"package","543":"data","746":"catalogue","878":"generic"}[chunkId] + "." + {"375":"1dcc91ba","414":"4cff0dd8","529":"96ee48d3","543":"a577fb54","746":"baf3a2dd","878":"878bc46a"}[chunkId] + ".js";
};